var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "envio-contabilidade-page"
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.loading
    },
    on: {
      "click": _vm.carregarTudo
    }
  }, [_c('i', {
    staticClass: "fa fa-sync mr-1"
  }), _vm._v(" Atualizar ")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.novaConfiguracao
    }
  }, [_c('i', {
    staticClass: "fa fa-plus mr-1"
  }), _vm._v(" Nova configuração ")])])])]), _c('b-tabs', {
    attrs: {
      "content-class": "mt-4"
    },
    model: {
      value: _vm.activeTab,
      callback: function callback($$v) {
        _vm.activeTab = $$v;
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Configurações"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Destinatários")]), _c('th', [_vm._v("Rotina")]), _c('th', [_vm._v("Período")]), _c('th', [_vm._v("Próxima execução")]), _c('th', [_vm._v("Última execução")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ações")])])]), _c('tbody', [_vm._l(_vm.configuracoes, function (configuracao) {
    return _c('tr', {
      key: configuracao.id
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(configuracao.nome))])]), _c('td', [_c('b-badge', {
      attrs: {
        "variant": configuracao.ativo ? 'success' : 'secondary'
      }
    }, [_vm._v(" " + _vm._s(configuracao.ativo ? "Ativo" : "Inativo") + " ")])], 1), _c('td', [_vm._v(_vm._s(_vm.listaEmails(configuracao.emails)))]), _c('td', [_vm._v(" Dia " + _vm._s(configuracao.dia_mes) + ": gera 00:00-06:00 e envia às 07:00 ")]), _c('td', [_vm._v(_vm._s(_vm.labelPeriodo(configuracao.periodo)))]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(configuracao.proxima_execucao)))]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(configuracao.ultima_execucao)))]), _c('td', {
      staticClass: "text-right text-nowrap"
    }, [_c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Editar',
        expression: "'Editar'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-light-primary btn-icon mr-2",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.editarConfiguracao(configuracao);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pen"
    })]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Enviar teste',
        expression: "'Enviar teste'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-light-info btn-icon mr-2",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.enviarTeste(configuracao);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-paper-plane"
    })]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Histórico',
        expression: "'Histórico'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-light btn-icon mr-2",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.verHistorico(configuracao);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-history"
    })]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: configuracao.ativo ? 'Desativar' : 'Ativar',
        expression: "\n                        configuracao.ativo ? 'Desativar' : 'Ativar'\n                      ",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-icon mr-2",
      class: configuracao.ativo ? 'btn-light-warning' : 'btn-light-success',
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.alterarStatusConfiguracao(configuracao);
        }
      }
    }, [_c('i', {
      class: configuracao.ativo ? 'fa fa-ban' : 'fa fa-check'
    })]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Excluir',
        expression: "'Excluir'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-light-danger btn-icon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.excluirConfiguracao(configuracao);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])]);
  }), !_vm.loading && _vm.configuracoes.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" Nenhuma configuração encontrada. ")])]) : _vm._e(), _vm.loading ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" Carregando configurações... ")])]) : _vm._e()], 2)])])])])]), _c('b-tab', {
    attrs: {
      "title": "Histórico"
    }
  }, [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-4"
  }, [_c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Histórico ")]), _vm.configuracaoHistorico ? _c('span', {
    staticClass: "text-muted mt-2"
  }, [_vm._v(" Configuração: " + _vm._s(_vm.configuracaoHistorico.nome) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "card-toolbar"
  }, [_vm.configuracaoHistorico ? _c('button', {
    staticClass: "btn btn-light mr-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limparFiltroHistorico
    }
  }, [_vm._v(" Limpar filtro ")]) : _vm._e(), _c('button', {
    staticClass: "btn btn-light-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.loadingExecucoes
    },
    on: {
      "click": _vm.carregarExecucoes
    }
  }, [_c('i', {
    staticClass: "fa fa-sync mr-1"
  }), _vm._v(" Atualizar Histórico ")])])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Competência")]), _c('th', [_vm._v("Período")]), _c('th', [_vm._v("Tipo de execução")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Início")]), _c('th', [_vm._v("Fim")]), _c('th', [_vm._v("Tamanho do pacote")]), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Ações")])])]), _c('tbody', [_vm._l(_vm.execucoes, function (execucao) {
    return _c('tr', {
      key: execucao.id
    }, [_c('td', [_vm._v(_vm._s(execucao.competencia))]), _c('td', [_vm._v(_vm._s(_vm.formatPeriodo(execucao.data_inicial, execucao.data_final)))]), _c('td', [_vm._v(_vm._s(_vm.labelTipoExecucao(execucao.tipo_execucao)))]), _c('td', [_c('StatusBadge', {
      attrs: {
        "status": execucao.status
      }
    })], 1), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(execucao.iniciado_em)))]), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(execucao.finalizado_em)))]), _c('td', [_vm._v(_vm._s(_vm.formatBytes(execucao.zip_size)))]), _c('td', {
      staticClass: "text-right text-nowrap"
    }, [_c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Baixar pacote',
        expression: "'Baixar pacote'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-light-primary btn-icon mr-2",
      attrs: {
        "type": "button",
        "disabled": !_vm.temPacote(execucao)
      },
      on: {
        "click": function click($event) {
          return _vm.baixarPacote(execucao);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-download"
    })]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Reenviar e-mail',
        expression: "'Reenviar e-mail'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-light btn-icon mr-2",
      attrs: {
        "type": "button",
        "disabled": !_vm.temPacote(execucao)
      },
      on: {
        "click": function click($event) {
          return _vm.reenviar(execucao);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-envelope"
    })]), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Detalhes',
        expression: "'Detalhes'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-light-info btn-icon",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.detalharExecucao(execucao);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })])])]);
  }), !_vm.loadingExecucoes && _vm.execucoes.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" Nenhuma execução encontrada. ")])]) : _vm._e(), _vm.loadingExecucoes ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-8",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" Carregando Histórico... ")])]) : _vm._e()], 2)])])])])])], 1), _c('ConfigFormModal', {
    attrs: {
      "show": _vm.showConfigModal,
      "value": _vm.configuracaoSelecionada,
      "itens": _vm.itens,
      "saving": _vm.savingConfig
    },
    on: {
      "close": _vm.fecharConfigModal,
      "save": _vm.salvarConfiguracao
    }
  }), _c('ExecucaoDetalheModal', {
    attrs: {
      "show": _vm.showDetalheModal,
      "execucao": _vm.execucaoSelecionada
    },
    on: {
      "close": _vm.fecharDetalheModal,
      "download": _vm.baixarPacote,
      "resend": _vm.reenviar
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Envio automático para contabilidade ")]), _c('span', {
    staticClass: "text-muted mt-3 font-weight-bold font-size-sm"
  }, [_vm._v(" Configure a rotina mensal, acompanhe o Histórico e baixe o Pacote ZIP. ")])]);
}];
export { render, staticRenderFns };